import { MenuItem, Divider } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { useDispatch, useSelector } from 'react-redux';

import ChartIconComponent from 'components/Icons/ChartIcon';
import KPIIconComponent from 'components/Icons/KpiIcon';
import TableIcomComponent from 'components/Icons/TableIcon';
import VarianceIcon from 'components/Icons/VarianceIcon';
import AddPageIcon from 'components/Icons/AddPageIcon';
import { AppDispatch } from 'utils/GlobalHelpers';
import { openPageModal, getSelectedPage } from 'redux/DashboardSliceV2';

export interface Properties {
  onSelectInstrument: (instrument: string) => void;
  flags?: any;
  isCreateButton?: boolean;
}

const InstrumentMenuList = ({ flags, onSelectInstrument, isCreateButton }: Properties) => {
  const dispatch: AppDispatch = useDispatch();
  const selectedPage = useSelector(getSelectedPage);
  const handleCreatePage = () => {
    dispatch(openPageModal({}));
  };

  return (
    <>
      {selectedPage && (
        <>
          <MenuItem onClick={() => onSelectInstrument('kpi')}>
            <KPIIconComponent
              width={'21.05px'}
              height={'21.05px'}
              color={'#787878'}
              marginRight='.5rem'
            />
            KPI
          </MenuItem>
          <MenuItem onClick={() => onSelectInstrument('line')}>
            <ChartIconComponent
              marginRight='.5rem'
              width={'21.05px'}
              height={'21.05px'}
              color={'#787878'}
            />
            Chart
          </MenuItem>
          <MenuItem onClick={() => onSelectInstrument('table')}>
            <TableIcomComponent
              marginRight='.5rem'
              width={'21.05px'}
              height={'21.05px'}
              color={'#787878'}
            />{' '}
            Table
          </MenuItem>
          {flags?.dashboardVariance && (
            <MenuItem onClick={() => onSelectInstrument('variance')}>
              <VarianceIcon marginRight='.5rem' width={'18px'} height={'18px'} color={'#787878'} />
              Variance
            </MenuItem>
          )}
        </>
      )}

      {isCreateButton && (
        <>
          {selectedPage && <Divider color={'#787878'} />}
          <MenuItem onClick={() => handleCreatePage()}>
            <AddPageIcon marginRight='.5rem' width={'18px'} height={'18px'} color={'#787878'} />
            New Page
          </MenuItem>
        </>
      )}
    </>
  );
};

export default withLDConsumer()(InstrumentMenuList);
